import React, { useState } from "react";

import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { Box, Button, CardMedia, Stack, TextField, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { some } from "lodash";

import { IFormikValues } from "../EditWindow";

export const NotableInvestments: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<IFormikValues>();
  const [inputCompany, setInputCompany] = useState<{ company_name: string } | null>(null);
  const [hasCompany, setHasCompany] = useState<boolean>(false);

  function hasCompanyCheck(arr: any, companyNameToCheck: string) {
    return some(arr, { company_name: companyNameToCheck });
  }

  return (
    <div style={{ width: "100%", borderRadius: "8px", backgroundColor: "#fff" }}>
      <Stack direction={"column"} sx={{ padding: "32px", alignItems: "flex-end" }} gap={"16px"}>
        {values.investments.map((item) => (
          <Stack sx={{ width: "100%" }} key={item.id} direction={"row"}>
            <Box sx={{ width: "70px", height: "60px", marginRight: "10px" }}>
              {item.company_logo && (
                <CardMedia
                  key={item.company_logo}
                  component="img"
                  height="60px"
                  sx={{ minWidth: "60px", maxWidth: "60px" }}
                  src=""
                  image={item.company_logo}
                />
              )}
            </Box>
            <Stack direction={"row"} justifyContent={"space-between"} sx={{ width: "100%" }}>
              <Typography sx={{ fontWeight: "bold" }}>{item.company_name}</Typography>
              <CancelRoundedIcon
                sx={{ color: "#5d7782", cursor: "pointer" }}
                onClick={() => {
                  setFieldValue(
                    "investments",
                    values.investments.filter((i) => i.company_name !== item.company_name)
                  );
                }}
              />
            </Stack>
          </Stack>
        ))}
        <TextField
          value={inputCompany?.company_name || ""}
          onChange={(e) => {
            setInputCompany({ company_name: e.target.value });
            setHasCompany(hasCompanyCheck(values.investments, e.target.value));
          }}
          sx={{ width: "100%", marginBottom: "13px" }}
          label="Company Name"
        />
        <Button
          disabled={!inputCompany?.company_name || hasCompany}
          onClick={() => {
            setFieldValue("investments", [...values.investments, inputCompany]);
            setInputCompany(null);
          }}
          sx={{ width: "fit-content" }}
          variant="outlined"
        >
          Add
        </Button>
      </Stack>
    </div>
  );
};
